<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">


                <b-form-row>
                    <b-col lg="4" sm="12" class="text-left">
                        <lg-finder-page-item-bem-permanente :label="'Item:'" v-model="form.item" id="finderItem"
                            @onselect="handleItemBemPermanenteSelect" invalidFeedback="" :prefix="[prefix, title]">
                        </lg-finder-page-item-bem-permanente>
                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <lg-finder-page-pessoa id="finderResponsavelTarefa" label="Responsável:"
                            @onselect="handleSelectResponsavelTarefa" v-model="form.responsavel"
                            invalidFeedback="Informe um responsável!" :prefix="prefix + title + ' > '">
                        </lg-finder-page-pessoa>
                    </b-col>


                    <lg-form-date invalidFeedback="A data de deve ser informada!" description="" v-model="form.dataPrev"
                        label="Data Prev. Devolução:" cols="12" sm="6" md="2" />

                    <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataPrevAte" label="Até:" cols="12" sm="6" md="2" />


                    <b-col lg="4" sm="12" class="text-left">
                        <lg-finder-page-empresa id="finderEmpresaOrigem" @input="handleSelectEmpresaOrigem"
                            :label="'Empresa  Origem:'" v-model="form.empresaOrigem"
                            invalidFeedback="Informe uma unidade administrativa!" :prefix="updatedPrefix">
                        </lg-finder-page-empresa>

                    </b-col>


                    <b-col lg="4" sm="12" class="text-left">
                        <lg-finder-page-unidade-administrativa
                            :podeMudarDepartamento="temPrivilegioGerenciarPatrimonio()"
                            :podeApagarDepartamento="temPrivilegioGerenciarPatrimonio()"
                            @onselect="handleSelectUnidadeAdministrativaOrigem" :label="'Unidade de Origem:'"
                            v-model="form.unidadeOrigem" invalidFeedback="Informe uma unidade administrativa!"
                            :prefix="prefix + title + ' > '">
                        </lg-finder-page-unidade-administrativa>
                    </b-col>


                    <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataDevolucao" label="Data Devolução:" cols="12" sm="6" md="2" />

                    <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataDevolucaoAte" label="Até:" cols="12" sm="6" md="2" />


                    <b-col lg="4" sm="12" class="text-left">
                        <lg-finder-page-empresa id="finderEmpresaDestino" @input="handleSelectEmpresaDestino"
                            :label="'Empresa  Destino:'" v-model="form.empresaDestino"
                            invalidFeedback="Informe uma unidade administrativa!" :prefix="updatedPrefix">
                        </lg-finder-page-empresa>

                    </b-col>


                    <b-col lg="4" sm="12" class="text-left">
                        <lg-finder-page-unidade-administrativa @onselect="handleSelectUnidadeAdministrativaDestino"
                            :label="'Unidade de Destino:'" v-model="form.unidadeDestino"
                            invalidFeedback="Informe uma unidade administrativa!" :prefix="prefix + title + ' > '">
                        </lg-finder-page-unidade-administrativa>
                    </b-col>

                    <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataEmprestimo" label="Data Emprestimo:" cols="12" sm="6" md="2" />

                    <lg-form-date invalidFeedback="A data limite deve ser informada!" description=""
                        v-model="form.dataEmprestimoAte" label=" Até:" cols="12" sm="6" md="2" />


                </b-form-row>


                <b-form-row>


                    <b-col cols="12" class="text-right mb-2">

                        <b-button id="limparEmprestimo" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" /> &nbsp;
                            </div>
                            <b-tooltip target="limparEmprestimo" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button id="localizarEmprestimo" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarEmprestimo" title="Localizar"></b-tooltip>
                        </b-button>

                        <b-button v-if="temPrivilegioIncluir()" id="addEmprestimo" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="showModalCadastro">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="plus" /> &nbsp;
                            </div>
                            <b-tooltip target="addEmprestimo" title="Adicionar novo..."></b-tooltip>
                        </b-button>


                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #empty>
                        <p>
                            Nenhum Registro encontrado
                        </p>
                    </template>

                    <template v-slot:cell(guiasaida)="row">
                        <div :id="'relatorioPdf-' + row.item.id">
                            <img @click="gerarRelatorioGuiaSaida(row.item.id)" :src="pdf" class="img img--clickable" alt="PDF" />
                            <b-tooltip :target="'relatorioPdf-' + row.item.id" title="Guia de saída..."></b-tooltip>

                        </div>
                    </template>

                    <template v-slot:cell(termodivida)="row">
                        <div :id="'relatorioTermoDividaPdf-' + row.item.id">
                            <img @click="gerarRelatorioTermoDivida(row.item.id)" :src="pdf" class="img img--clickable" alt="PDF" />
                            <b-tooltip :target="'relatorioTermoDividaPdf-' + row.item.id" title="Termo de Empréstimo..."></b-tooltip>

                        </div>
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button :disabled="!temPrivilegioEditar()"
                            v-if="!row.item.previsaoDevolucao || row.item.previsaoDevolucao == ''"
                            :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                            @click="showModalCadastro(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>


                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <EmprestimoForm :id="id" @close="cancelar" v-if="showModal" :prefix="prefix + title + ' > '"></EmprestimoForm>
    </b-card>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import moment from 'moment'
import EmprestimoForm from "./EmprestimoForm.vue";
import PdfIcon from "@/core/assets/icons/pdf.png";

import ResourceService from "@/core/api/ResourceService";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import LgFinderPageItemBemPermanente from "@/components//Finders/LgFinderPageItemBemPermanente.vue";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFinderPageEmpresa from '@/components/Finders/LgFinderPageEmpresa.vue';

import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
export default {
    components: {
        LgFinderPagePessoa,
        LgFinderPageItemBemPermanente,
        LgFinderPageEmpresa,
        LgFormDate,
        LgFinderPageUnidadeAdministrativa,
        EmprestimoForm
    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    props: {
        prefix: {
            type: String,
            default: ""
        },
    },

    data() {
        return {
            pdf: PdfIcon,
            id: null,
            showModal: false,
            title: 'Empréstimo Item Bem Permanente',
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            form: {
                item: {},
                responsavel: {},
                dataPrev: '',
                dataPrevAte: '',
                empresaDestino: {},
                empresaOrigem: {},
                unidadeOrigem: {},
                unidadeDestino: {},
                dataDevolucao: "",
                dataDevolucaoAte: "",
                dataEmprestimo: '',
                dataEmprestimoAte: '',

            },
        };
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/emprestimo`);
    },

    created() {
        const brand = JSON.parse(localStorage.getItem("context"));
        this.form.unidadeOrigem = brand.departamento;

    },

    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        updatedPrefix() {

            return [this.prefix, this.title];
        },

        tableFields() {
            return [
                {
                    key: "data", label: " Data Emprestimo", formatter: (value) => value ? moment(value).format('DD/MM/YYYY') : "",
                },
                {
                    key: "previsaoDevolucao", label: "Data Prev. Devolução", formatter: (value) => value ? moment(value).format('DD/MM/YYYY') : "",
                },
                { key: "departamentoOrigem.nome", label: "Origem" },

                { key: "departamentoDestino.nome", label: "Destino" },

                { key: "pessoa.nome", label: "Responsável" },
                { key: "guiasaida", label: "" },
                { key: "termodivida", label: "" },

                { key: "action", label: " ", tdClass: "w-1" },
            ];
        },
    },
    methods: {
        async gerarRelatorioTermoDivida(id) {
            this.param = {};
            this.param.id = id

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-termo-emprestimo');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } finally {
                this.busy = false;
            }


        },
        async gerarRelatorioGuiaSaida(id) {
            this.param = {};
            this.param.id = id

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-guia-saida');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } finally {
                this.busy = false;
            }


        },
        temPrivilegioIncluir() {
            return verificaPrivilegio(PrivilegiosEnum.EMPRESTIMO_BEM_PERMANENTE_INCLUIR);

        },

        temPrivilegioGerenciarPatrimonio() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PATRIMONIO);

        },

        temPrivilegioEditar() {
            return verificaPrivilegio(PrivilegiosEnum.EMPRESTIMO_BEM_PERMANENTE_EDITAR);

        },


        cancelar() {
            this.showModal = false;
            this.id = null;
            this.load();
        },
        showModalCadastro(item) {
            if (item)
                this.id = item.id;

            this.showModal = true;

        },
        clearForm() {
            const brand = JSON.parse(localStorage.getItem("context"));
            this.form = {
                item: {},
                responsavel: {},
                dataPrev: '',
                dataPrevAte: '',
                empresaDestino: {},
                empresaOrigem: {},
                unidadeOrigem: !this.temPrivilegioGerenciarPatrimonio() ? brand.departamento : {},
                unidadeDestino: {},
                dataDevolucao: "",
                dataDevolucaoAte: "",
                dataEmprestimo: '',
                dataEmprestimoAte: '',
            };
            this.load();


        },
        handleSelectResponsavelTarefa(item) {
            this.form.pessoa = item;
            this.load();

        },
        handleItemBemPermanenteSelect(item) {
            this.form.item = item;
            this.load();

        },
        async load() {

            this.filtro = {};

            if (this.form.unidadeOrigem && this.form.unidadeOrigem.id)
                this.filtro.unidadeOrigem = this.form.unidadeOrigem.id


            if (this.form.unidadeDestino && this.form.unidadeDestino.id)
                this.filtro.unidadeDestino = this.form.unidadeDestino.id

            if (this.form.empresaOrigem && this.form.empresaOrigem.id)
                this.filtro.empresaOrigem = this.form.empresaOrigem.id


            if (this.form.empresaDestino && this.form.empresaDestino.id)
                this.filtro.empresaDestino = this.form.empresaDestino.id

            if (this.form.item && this.form.item.id)
                this.filtro.item = this.form.item.id


            if (this.form.pessoa && this.form.pessoa.id)
                this.filtro.pessoa = this.form.pessoa.id

            if (this.form.dataEmprestimo && this.form.dataEmprestimo != "")
                this.filtro.dataEmprestimo = new Date(
                    this.form.dataEmprestimo
                ).toLocaleDateString();

            if (this.form.dataEmprestimoAte && this.form.dataEmprestimoAte != "")
                this.filtro.dataEmprestimoAte = new Date(
                    this.form.dataEmprestimoAte
                ).toLocaleDateString();

            if (this.form.dataDevolucao && this.form.dataDevolucao != "")
                this.filtro.dataDevolucao = new Date(
                    this.form.dataDevolucao
                ).toLocaleDateString();

            if (this.form.dataDevolucaoAte && this.form.dataDevolucaoAte != "")
                this.filtro.dataDevolucaoAte = new Date(
                    this.form.dataDevolucaoAte
                ).toLocaleDateString();

            if (this.form.dataPrev && this.form.dataPrev != "")
                this.filtro.dataPrev = new Date(
                    this.form.dataPrev
                ).toLocaleDateString();

            if (this.form.dataPrevAte && this.form.dataPrevAte != "")
                this.filtro.dataPrevAte = new Date(
                    this.form.dataPrevAte
                ).toLocaleDateString();

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });

        },
        async handleSelectEmpresaOrigem(empresa) {
            this.form.empresaOrigem = empresa;
            this.load();

        },

        async handleSelectEmpresaDestino(empresa) {
            this.form.empresaDestino = empresa;
            this.load();

        },
        async handleSelectUnidadeAdministrativaOrigem(unidadeAdministrativa) {
            this.form.unidadeOrigem = unidadeAdministrativa;
            this.load();

        },
        async handleSelectUnidadeAdministrativaDestino(unidadeAdministrativa) {
            this.form.unidadeDestino = unidadeAdministrativa;
            this.load();
        },

    },
};
</script>
